import { MerchantLogo } from "@/components/application/merchant-logo/merchant-logo";
import { cx } from "@/utils/cx";

export type TeamBrand = { id: string; name: string; logoUrl?: string | null };

// What the column is wide enough for; the rest collapse into the ellipsis.
const MAX_LOGOS = 5;
const COMPACT_LOGOS = 3;

const LOGO_SHOWN_WHEN_ROOMY = "@[158px]:inline-flex";
const LOGO_SHOWN_WHEN_TIGHT = "@[106px]:inline-flex";
const ELLIPSIS_DROPPED_WHEN_ROOMY = "@[158px]:hidden";
const ELLIPSIS_DROPPED_WHEN_TIGHT = "@[106px]:hidden";

export const TeamBrandsCell = ({ brands }: { brands: TeamBrand[] }) => {
  if (brands.length === 0) return <span className="text-sm text-tertiary">—</span>;

  const shown = brands.slice(0, MAX_LOGOS);
  const overflowVisibility =
    brands.length > MAX_LOGOS
      ? ""
      : brands.length > COMPACT_LOGOS
        ? ELLIPSIS_DROPPED_WHEN_ROOMY
        : ELLIPSIS_DROPPED_WHEN_TIGHT;

  return (
    <div className="@container">
      <div className="flex items-center gap-0.5">
        <span className="mr-1.5 text-sm font-medium text-secondary tabular-nums">{brands.length}</span>
        {shown.map((brand, index) => (
          <span
            key={brand.id}
            className={cx("hidden", index < COMPACT_LOGOS ? LOGO_SHOWN_WHEN_TIGHT : LOGO_SHOWN_WHEN_ROOMY)}
          >
            <MerchantLogo
              name={brand.name}
              logoUrl={brand.logoUrl}
              size="xs"
              className="rounded-[4px] ring-1 ring-secondary"
            />
          </span>
        ))}
        <span className={cx("pl-1 text-sm text-tertiary", overflowVisibility)}>…</span>
      </div>
    </div>
  );
};
